'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');

const _FifteenMinutesInMillis=timespan.fromMinutes(15).totalMilliseconds();let

FatigueExtensions=function(){
function FatigueExtensions(self){_classCallCheck(this,FatigueExtensions);
this._self=self;
}FatigueExtensions.prototype.





























































peakConsistentWithFatigueApi=function peakConsistentWithFatigueApi(duties){
if(duties.length===0){
return;
}

const typeOrder={e:3,f:2,s:1};

const dutyPosts=TimeInterval.compress(duties).flatMap(function(duty){return[{type:'s',time:duty.start,duty:duty},{type:'e',time:duty.end,duty:duty}]});
const fatiguePosts=this._self.map(function(point){return{type:'f',time:point.time,point:point}});
const allPosts=_.sortBy(fatiguePosts.concat(dutyPosts),function(p){return p.time.getTime()},function(_ref){let{type:type}=_ref;return typeOrder[type]});

let inDuty=!1;
let sawFatigueInDuty=!1;
let currentPeak=null;
let lastFatiguePostPassed=null;
let lastDutyPassed=null;

const makePoint=function(time,original){return _.defaults({time:time},original)};

const trySetPeak=function(fatiguePost,timeOverride){
if(!fatiguePost){
return;
}

if(!currentPeak||fatiguePost.point.value>currentPeak.value){
fatiguePost.peaking=!0;
const{point:point}=fatiguePost;
currentPeak=timeOverride?makePoint(timeOverride,point):point;
}
};

for(const post of allPosts){
if(post.type==='f'){
if(inDuty){
sawFatigueInDuty=!0;
trySetPeak(post);
}else if(currentPeak&&lastFatiguePostPassed.peaking&&post.point.value>currentPeak.value){

currentPeak=makePoint(lastDutyPassed.end,currentPeak);
}
lastFatiguePostPassed=post;
}else if(post.type==='s'){
sawFatigueInDuty=!1;
inDuty=!0;
}else if(post.type==='e'){
inDuty=!1;
if(!sawFatigueInDuty&&lastFatiguePostPassed){
trySetPeak(lastFatiguePostPassed,post.duty.start);
}
lastDutyPassed=post.duty;
}
}

return currentPeak;
};FatigueExtensions.

extend=function extend(self){
return new FatigueExtensions(self);
};_createClass(FatigueExtensions,[{key:'fatigueAtTime',get:function(){const fatigue=this._self;if(fatigue.length===0){return function(time){return void 0}}const fatigueStartTime=_.first(fatigue).time.getTime();const fatigueEndTime=_.last(fatigue).time.getTime();let fatigueIndex=0;return function(time){time=typeof time=='number'?time:time.getTime();if(time<fatigueStartTime){if(fatigueStartTime-time>=_FifteenMinutesInMillis){return void 0}fatigueIndex=0;time=fatigueStartTime}else if(time>fatigueEndTime){if(time-fatigueEndTime>=_FifteenMinutesInMillis){return void 0}fatigueIndex=fatigue.length-1;time=fatigueEndTime}if(time<fatigue[fatigueIndex].time.getTime()){fatigueIndex=_.findLastIndex(fatigue,function(p){return p.time.getTime()<=time},fatigueIndex)}fatigueIndex=_.findIndex(fatigue,function(p){return p.time.getTime()>=time},fatigueIndex);return fatigue[fatigueIndex].value}}},{key:'maxDuring',get:function(){const fatigueAtTime=this.fatigueAtTime;return function(timeInterval){let now=timeInterval.start.getTime();const end=timeInterval.end.getTime();let max=-1;while(now<=end){const fatigue=fatigueAtTime(now);if(fatigue!==void 0&&fatigue>max){max=fatigue}now+=_FifteenMinutesInMillis}return max===-1?void 0:max}}}]);return FatigueExtensions}();


module.exports=FatigueExtensions.extend;
//# sourceMappingURL=fatigueExtensions.js.map
